exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper {\r\n  height: 100%;\r\n}\r\n\r\n.main-content {\r\n  height: 100%;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .content-wrapper {\r\n    top: 68px;\r\n    padding: 0;\r\n    position: absolute;\r\n    width: 100%;\r\n    left: 0;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/ticket/my-tickets/my-tickets.component.css
// module id = ../../../../../src/app/ticket/my-tickets/my-tickets.component.css
// module chunks = main